import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../store";

const selectUserState = (state: RootState) => state.user;

export const selectUserWorkingHours = createSelector(
  selectUserState,
  userState => userState.workingHours,
);
export const selectUserWorkingDays = createSelector(
  selectUserState,
  userState => userState.workingDays,
);
